import infoIconImg from './info_icon.png';
import { playUiInfo } from '../../../../../assets/preloadSounds';
import './InfoPopupButton.css';

export type InfoPopupButtonProps = {
  onClick?: () => void;
  /** Absolute left position in design px. */
  left: number;
  /** Absolute top position in design px. */
  top: number;
  /** Visual scale relative to the 50×50 design size. Default: 1. */
  scale?: number;
  className?: string;
  ariaLabel?: string;
};

/** Info (?) popup trigger — icon-only control. */
export function InfoPopupButton({
  onClick,
  left,
  top,
  scale = 1,
  className,
  ariaLabel = 'Информация',
}: InfoPopupButtonProps) {
  return (
    <button
      type="button"
      className={['info-popup-button', className].filter(Boolean).join(' ')}
      style={{
        left,
        top,
        ['--info-popup-scale' as string]: scale,
      }}
      aria-label={ariaLabel}
      onClick={() => {
        playUiInfo();
        onClick?.();
      }}
    >
      <img
        className="info-popup-button__icon"
        src={infoIconImg}
        alt=""
        draggable={false}
      />
    </button>
  );
}
